"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderList = void 0;
const constants_1 = require("./constants");
const getOrderList = () => {
    try {
        return JSON.parse(localStorage.getItem(constants_1.ORDER_LIST_KEY) || '');
    }
    catch (e) {
        return [];
    }
};
exports.getOrderList = getOrderList;
